export enum DataRoomDrawerVariant {
  ADMIN,
  DCR_LIST,
}
